
import rules from "@/services/helpers/validation-rules";
import MultiplePhonePicker from "../../../components/form-components/MultiplePhonePicker.vue";
import DatePicker from "../../../components/form-components/DatePicker.vue";
import Vue from "vue";
import FileUploader from "@/components/form-components/FileUploader.vue";
import PhonePicker from "@/components/form-components/PhonePicker.vue";

export default Vue.extend({
  name: "General",

  components: {
    PhonePicker,
    FileUploader,
    DatePicker,
    MultiplePhonePicker,
  },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    errorMessages: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data: () => ({
    rules,
    optionalDocuments: ["marry_certificate"],
    model: {} as any,
    selects: {
      blood_type: ["I", "II", "III", "IV"] as Array<any>,
      countries: [] as Array<SelectComponentInterface>,
      languages: [] as Array<SelectComponentInterface>,
    },
    series: ["A", "B"],
    menu: false,
    foreignLanguages: [] as Array<any>,
    requiredDocuments: {} as any,
    hasId: false as boolean,
  }),

  watch: {
    menu(val) {
      setTimeout(() => {
        if (val && this.$refs.picker) {
          (this.$refs.picker as any).activePicker = "YEAR";
        }
      });
    },
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.model = this.value;
        this.foreignLanguages = this.model.foreign_languages;

        for (const document of this.model.abiturient_documents) {
          if (!document.type.startsWith("optional_copy_")) {
            this.requiredDocuments[document.type] = document;
          }
        }
      },
    },
    foreignLanguages: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit("input", this.foreignLanguages);
      },
    },
    hasId: {
      immediate: true,
      handler() {
        if (this.hasId) {
          delete this.model.abiturient.personal_code;
        }
      },
    },
  },

  computed: {
    genders() {
      return [
        {
          text: this.$t("applications.form.abiturient.sex.m"),
          value: "m",
        },
        {
          text: this.$t("applications.form.abiturient.sex.f"),
          value: "f",
        },
      ];
    },
    blood_type() {
      return [
        {
          text: "0 (I)",
          value: "1",
        },
        {
          text: "A (II)",
          value: "2",
        },
        {
          text: "B (III)",
          value: "3",
        },
        {
          text: "AB (IV)",
          value: "4",
        },
      ];
    },
    rh() {
      return [
        {
          text: this.$t("applications.form.abiturient.rh_positive"),
          value: "positive",
        },
        {
          text: this.$t("applications.form.abiturient.rh_negative"),
          value: "negative",
        },
      ];
    },
    residence_medium() {
      return [
        {
          text: this.$t("applications.form.abiturient.residence_medium_urban"),
          value: "urban",
        },
        {
          text: this.$t("applications.form.abiturient.residence_medium_rural"),
          value: "rural",
        },
      ];
    },
    id_series() {
      return [
        {
          text: "A",
          value: "A",
        },
        {
          text: "B",
          value: "B",
        },
        {
          text: "EA",
          value: "EA"
        },
        {
          text: "EC",
          value: "EC"
        }
      ];
    },
    personal_code_absence_reasons() {
      return [
        {
          text: "Reason1",
          value: "Reason1",
        },
        {
          text: "Reason2",
          value: "Reason2",
        },
        {
          text: "Reason3",
          value: "Reason3",
        },
      ];
    },
    language_level() {
      return [
        {
          text: this.$t("applications.form.foreign_languages.beginner"),
          value: "beginner",
        },
        {
          text: this.$t("applications.form.foreign_languages.medium"),
          value: "medium",
        },
        {
          text: this.$t("applications.form.foreign_languages.excellent"),
          value: "excellent",
        },
      ];
    },
    maxIdRelease() {
      return this.$moment().format("YYYY-MM-DD");
    },
    user() {
      return this.$store.getters["user/info"];
    },
    civilStatuses() {
      return [
        {
          text: this.$t(
            "applications.form.family_members.civil_status.is_married"
          ),
          value: true,
        },
        {
          text: this.$t(
            "applications.form.family_members.civil_status.no_married"
          ),
          value: false,
        },
      ];
    },
  },

  async mounted() {
    await this.loadData();
    this.$forceUpdate();
  },

  methods: {
    submit() {
      this.$nextTick(() => {
        this.$emit("submit");
      });
    },
    setServerResponse() {
      if (!this.model.application.id) {
        this.model.abiturient.first_name = this.user.first_name;
        this.model.abiturient.last_name = this.user.last_name;
      }

      if (!this.model.abiturient_contacts.length && this.user.phone) {
        this.model.abiturient_contacts.push(this.user.phone);
      }

      if (this.$route.params.id) {
        this.hasId = !this.model.abiturient.personal_code;
      }

      if (this.selects.countries.length === 1) {
        const [{ value }] = this.selects.countries;
        this.model.abiturient.nationality = value;
      }
    },
    validate(key: string) {
      this.$nextTick(() => {
        this.$emit("validate", key);
      });
    },
    async loadData() {
      try {
        this.selects.countries = await this.$API.countries().getList();
        this.selects.languages = await this.$API.languages().getList();
        this.setServerResponse();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    save(date: string) {
      (this.$refs.menu as any).save(date);
    },
    add(): void {
      this.foreignLanguages.push({});
    },
    remove(index: number): void {
      this.foreignLanguages.splice(index, 1);
    },
    addDocuments(): void {
      const lastOptionalDocument = [...this.model.abiturient_documents]
        .reverse()
        .find((item: any) => item.type.startsWith("optional_"));

      if (lastOptionalDocument) {
        const [, , index] = lastOptionalDocument.type.split("_");

        this.model.abiturient_documents.push({
          type: `optional_copy_${Number(index) + 1}`,
          file: null,
        });
      } else {
        this.model.abiturient_documents.push({
          type: `optional_copy_1`,
          file: null,
        });
      }
    },
    removeDocuments(index: number): void {
      this.model.abiturient_documents.splice(index, 1);
    },
    uploadFile(type: string, event: any, key: string = ""): void {
      const documentIndex = this.model.abiturient_documents.findIndex(
        (item: any) => item.type === type
      );

      if (documentIndex !== -1) {
        this.model.abiturient_documents[documentIndex].file = event;
        this.model.abiturient_documents[documentIndex].url = "";
      } else {
        this.model.abiturient_documents.push({ type, file: event });
      }

      this.requiredDocuments[type] = event;
      if (key) {
        this.$emit("validate", key);
      }
    },
  },
});
